/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React from 'react';
import * as CustomWidgets from './customwidgets';

const Admin = (props) => {
    const [next, setNext] = React.useState('search');
    const [next2, setNext2] = React.useState('search');
    const [tabActive, setTabActive] = React.useState('AGENT');
    const [tabs, setTabs] = React.useState([{
        name: 'AGENT',
        title: 'Usuario'
    }, {
        name: 'ROLE',
        title: 'Roles'
    }]);

    React.useEffect(() => {
        setNext(props.next);
        setNext2(props.next);
    }, [props.next]);

    const updateNext = (next) => {
        setNext(next)
    }
    const updateNext2 = (next) => {
        setNext2(next)
    }

    const changeTab = (tab: string) => {
        setNext('search');
        setNext2('search');
        setTabActive(tab);
    }

    return (
        <div className="size-12">
            <div className="card">
                <div className="form-row hdr_transaction">
                    <div className='col-ico '>
                        <i className="ibon-autodeposit inb4"></i>
                    </div>
                    <h3 className='col-8 fix-elm-title-widget'>
                        Administrador de roles y usuarios
                    </h3> 
                    <div className='col-3 txt-right fix-dos-icos'></div>
                </div>
                <div className="size-12 tabBox">
                    <ul>
                        {
                            tabs.map((item, index) => {
                                return <li key={`amin-tabs-${index}`} className={tabActive === item.name ? 'active' : ''} onClick={changeTab.bind(this, item.name)}>{item.title}</li>
                            })
                        }

                    </ul>
                </div>
                {
                    tabActive === 'ROLE' &&
                    <CustomWidgets.RoleList
                        next={next}
                        updateNext={updateNext}
                        item={props.item}
                        addWidget={props.addWidget}
                        key={props.index}
                        openModal={props.openModal}
                        changeOpenModal={props.changeOpenModal}
                        contentModal={props.contentModal}
                        changeContentModal={props.changeContentModal}
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        pos={props.pos}
                    />
                }
                {
                    tabActive === 'AGENT' &&
                    <CustomWidgets.AgentList
                        next={next2}
                        updateNext={updateNext2}
                        addWidget={props.addWidget}
                        key={props.index}
                        openModal={props.openModal}
                        changeOpenModal={props.changeOpenModal}
                        contentModal={props.contentModal}
                        changeContentModal={props.changeContentModal}
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        pos={props.pos}
                    />
                }
            </div>
        </div>
    )
}

export default Admin;

